import Icon from '../Icon';
import './file-upload.css';
import { useEffect, useState } from "react";

function FileUpload({ defaultFileName, onChange = (_) => {}, onRemove = () => {} }) {
    const defaultFileText = "Nenhum arquivo selecionado";

    const [fileName, setFileName] = useState(defaultFileText);

    useEffect(() => {
        if (!defaultFileName) {
            return;
        }

        setFileName(defaultFileName);
    }, [defaultFileName]);

    const handleChange = (event) => {
        const file = event.target.files?.[0];
        setFileName(file ? file.name : defaultFileText);

        onChange(file);
    };

    function removeFile() {
        setFileName(defaultFileText);
        onRemove();
    }

    return (
        <div className="file-upload">
            <input
                id="pdf-upload"
                type="file"
                accept=".pdf"
                onChange={handleChange}
                className="file-upload-input"
            />

            <label htmlFor="pdf-upload" className="blue-button zoom-effect file-upload-button">
                Escolher arquivo
            </label>

            <span className="file-upload-name">{fileName}</span>

            <button type='button' className='file-remove-button' onClick={removeFile}>
                <Icon iconClass='icon-close' size={16} />
            </button>
        </div>
    );
}

export default FileUpload;